import React, {useCallback, useContext, useState} from 'react';
import * as PropTypes from 'prop-types';

import Icon from '@components/icon';
import DropdownToggle from 'ati-ui-react/components/DropdownToggle';

import { useLocalized } from 'utils/useLocalized';
import {DataContext} from 'contexts';
import { eventMetrics } from 'logic/requestParams';
import ScrollsPopoverContainer from 'components/Page/SearchResults/ScrollsPopoverContainer';
import BoardsPopoverContainer from 'components/Page/SearchResults/BoardsPopoverContainer';

import styles from './styles.modules.scss';
import i18nStrings from './strings';

const actions = {
    openFirm: 1,
    openBoardsPopup: 2,
    openScrollsPopup: 3
};

const FirmActionDropdown = ({atiId}) => {
    const strings = useLocalized(i18nStrings);
    const { openPassport, writeEvent } = useContext(DataContext);
    const [boardsPopoverVisible, setBoardsPopoverVisible] = useState(false);
    const [scrollsPopoverVisible, setScrollsPopoverVisible] = useState(false);
    const [dropdownActive, setDropdownActive] = useState(false);

    const onDropdownOptionClick = useCallback((option)=> {
        switch (option.id) {
            case actions.openBoardsPopup:
                writeEvent(eventMetrics.openInviteToBoards, [atiId]);
                setBoardsPopoverVisible(true);
                break;
            case actions.openScrollsPopup:
                writeEvent(eventMetrics.openAddToList, [atiId]);
                setScrollsPopoverVisible(true);
                break;
            case actions.openFirm:
                openPassport(atiId);
                break;
        }

        setDropdownActive(false);
    }, [setBoardsPopoverVisible, setScrollsPopoverVisible, writeEvent, openPassport, atiId]);

    return (
        <div className={styles['dropdown']}>
            <ScrollsPopoverContainer
                atiIds={[atiId]}
                visible={scrollsPopoverVisible}
                onPopoverVisibleChange={setScrollsPopoverVisible}
            />
            <BoardsPopoverContainer
                atiIds={[atiId]}
                visible={boardsPopoverVisible}
                onPopoverVisibleChange={setBoardsPopoverVisible}
            />
            <DropdownToggle
                capture
                active={dropdownActive}
                dropdown={(
                    <DropdownToggle.List
                        options={[
                            { id: actions.openScrollsPopup, name: strings.addToList },
                            { id: actions.openFirm, name: strings.openPassport },
                            { id: actions.openBoardsPopup, name: strings.inviteToBoard }
                        ]}
                        onClick={(option) => onDropdownOptionClick(option)}
                    />
                )}

                placement="bottom-left"
                onToggle={(active)=>setDropdownActive(active)}
            >
                <Icon
                    className={styles['dots']}
                    color="#8C969D"
                    name="ic_ellipsis"
                    size="m"
                />
            </DropdownToggle>
        </div>
    );
};

export default FirmActionDropdown;

FirmActionDropdown.propTypes = {
    atiId: PropTypes.string
};
